var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAircraftSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.48 13.7L13.5 9V3.5C13.5 2.67 12.83 2 12 2C11.17 2 10.5 2.67 10.5 3.5V9L2.52 13.7C2.2 13.88 2 14.23 2 14.6C2 15.3 2.67 15.8 3.34 15.61L10.5 13.51V19L8.24 20.35C8.09 20.44 8 20.61 8 20.78V21.28V21.36C8 21.69 8.31 21.93 8.62 21.85L11.54 21.12L12 21L12.38 21.09L12.8 21.2L14.7 21.68L15.37 21.85C15.69 21.93 15.99 21.69 15.99 21.36V20.99V20.78C15.99 20.6 15.9 20.44 15.75 20.35L13.5 19V13.5L20.66 15.6C21.33 15.8 22 15.3 22 14.6C22 14.23 21.8 13.88 21.48 13.7Z",
    fill: "#ACACAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11H20V9H22V11ZM22 6C22 6.55 21.55 7 21 7C20.45 7 20 6.55 20 6V3C20 2.45 20.45 2 21 2C21.55 2 22 2.45 22 3V6Z",
    fill: "#ACACAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAircraftSearchIcon);
export default __webpack_public_path__ + "static/media/aircraftSearchIcon.417ab635.svg";
export { ForwardRef as ReactComponent };